export const api = {
  questionManage: { // 调查问卷管理
    queryAllQuestionList: '/bms/queryQuestion/queryAllQuestionList', // 查询所有的调查项
    // queryAllPersonnelList: '/bms/queryQuestion/queryAllPersonnelList', // 查询所有的人员信息
    queryAllPersonnelList: '/cms/account/queryResultsByPag.json', // 查询所有的人员信息
    addQuestionnaire: '/bms/addQuestionnaire/addQuestionnaire.json', // 新增问卷调查信息
    updateQuestionnaire: '/bms/addQuestionnaire/updateQuestionnaire.json', // 修改问卷调查信息
    deleteQuestionnaire: '/bms/addQuestionnaire/deleteQuestionnaire', // 删除调查问卷信息
    queryQuestionnaire: '/bms/queryQuestionnaire/queryQuestionnaire', // 查询单条调查问卷信息
    publishQuestionnaire: '/bms/addQuestionnaire/publishQuestionnaire', // 发布调查问卷信息
    queryQuestionnaireList: '/bms/queryQuestionnaire/queryQuestionnaireList', // 分页查询调查问卷信息
    queryPersonnelCount: '/bms/queryQuestionnaire/queryPersonnelCount', // 作答人员数量统计
    queryQuestionnaireCount: '/bms/queryQuestionnaire/queryQuestionnaireCount', // 作答时长统计
    queryQuestionCount: '/bms/queryQuestionnaire/queryQuestionCount', // 查询调查问卷下面题目选项的个数
    queryOptionPersonnel: '/bms/queryQuestionnaire/queryOptionPersonnel.json', // 查询选项选择人员
  },
  surveyManage: { // 调查项管理
    addQuestion: '/bms/addQuestion/addQuestion', // 新增问卷项（问题）信息
    updateQuestion: '/bms/addQuestion/updateQuestion', // 修改问卷项（问题）信息
    deleteQuestion: '/bms/addQuestion/deleteQuestion', // 删除问题信息
    queryQuestionList: '/bms/queryQuestion/queryQuestionList', // 分页查询问题信息
    addQuestionCategory: '/bms/addQuestionCategory/addQuestionCategory', // 添加问题分类信息
    updateQuestionCategory: '/bms/addQuestionCategory/updateQuestionCategory', // 修改问题分类信息
    deleteQuestionCategory: '/bms/addQuestionCategory/deleteQuestionCategory', // 删除问题分类信息
    queryQuestionCategoryList: '/bms/queryQuestionCategory/queryQuestionCategoryList', // 查询所有问题分类信息列表
  }
}